// **************************************************************************
// CURRENCIES STATE
// Only contains operation loading states - actual data is in application/data store
// **************************************************************************
export interface CurrenciesState {
    updating: boolean;
}

export const initialCurrenciesState: CurrenciesState = {
    updating: false,
};
